import { produce } from 'immer';

import { storeFactory } from './storeFactory';

type Visibility = undefined | 'hidden' | 'minimized' | 'maximized';

type ChatUser = {
  name: string;
  email: string;
};

interface LiveChatStoreStateData {
  isInitialized: boolean;
  visibility: Visibility;
  user?: ChatUser;
}

interface LiveChatStoreStateFunctions {
  setIsInitialised: (isInitialized: boolean) => void;
  setChatUser: (user: ChatUser) => void;
  hideLiveChat: () => void;
  minimiseLiveChat: () => void;
  maximiseLiveChat: () => void;
  setLiveChatVisibility: (visibility: Visibility) => void;
}

const {
  store: liveChatStore,
  StoreProvider: LiveChatStoreProvider,
  useCreateStore: useCreateLiveChatStore,
} = storeFactory<LiveChatStoreStateData, LiveChatStoreStateFunctions>(
  () => ({
    isInitialized: false,
    visibility: undefined,
    user: undefined,
  }),
  (set) => ({
    setIsInitialised: (isInitialized: boolean) => {
      set((state) =>
        produce(state, (draft) => {
          draft.isInitialized = isInitialized;
        }),
      );
    },
    setChatUser: (user: ChatUser) => {
      set((state) =>
        produce(state, (draft) => {
          draft.user = user;
        }),
      );
    },
    setLiveChatVisibility: (visibility: Visibility) => {
      set((state) =>
        produce(state, (draft) => {
          draft.visibility = visibility;
        }),
      );
    },
    hideLiveChat: () => {
      set((state) =>
        produce(state, (draft) => {
          draft.visibility = 'hidden';
        }),
      );
    },
    minimiseLiveChat: () => {
      set((state) =>
        produce(state, (draft) => {
          draft.visibility = 'minimized';
        }),
      );
    },
    maximiseLiveChat: () => {
      set((state) =>
        produce(state, (draft) => {
          draft.visibility = 'maximized';
        }),
      );
    },
  }),
);

export { liveChatStore, LiveChatStoreProvider, useCreateLiveChatStore };
